import { render, staticRenderFns } from "./Or.vue?vue&type=template&id=c6f3bcfa&"
import script from "./Or.vue?vue&type=script&lang=js&"
export * from "./Or.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports